module.exports = __webpack_public_path__ + "img/wdrq2.9b57d4dc.png";